<template>
  <!-- leichter Titel wie die übrigen Verwaltungsseiten (Kundenwunsch 13.10.2026: „superadminseiten bitte ebenfalls
       umstellen“); Formular als Karte wie die Kundeneinstellungen -->
  <app-page lean>
    <div class="app-page-pad">
      <app-panel class="nc-panel" icon="userPlus" title="Kundendaten" flush>
        <div class="app-form nc-form">
          <div class="app-form-field">
            <label class="app-label" for="nc-name">Kundenname</label>
            <app-text-field id="nc-name" v-model="newcustomer.name" :error="nameError" @input="nameError = ''" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="nc-printname">Kundenname (Druck)</label>
            <app-text-field id="nc-printname" v-model="newcustomer.cust_printname" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="nc-url">Webseite</label>
            <app-text-field id="nc-url" v-model="newcustomer.customer_url" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="nc-tel">Telefonnummer</label>
            <app-text-field id="nc-tel" v-model="newcustomer.customer_tel" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="nc-printer-width">Druckerbreite</label>
            <app-text-field id="nc-printer-width" v-model="newcustomer.printer_width" />
          </div>
          <div class="app-form-field">
            <label class="app-label" for="nc-printer-types">Druckertypen</label>
            <app-text-field id="nc-printer-types" v-model="newcustomer.printer_types" />
          </div>
        </div>
        <div class="nc-foot">
          <app-button kind="primary" icon="plus" :loading="loading" @click="createCustomer">Kunde anlegen</app-button>
        </div>
      </app-panel>
    </div>
    <app-toast v-model="okToast" icon="check" kind="ok" :text="okText" closable />
    <app-toast v-model="errorToast" icon="alert" kind="error" :timeout="6000" text="Der Kunde konnte nicht angelegt werden." closable />
  </app-page>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  mixins: [],
  computed: {},
  data() {
    return {
      loading: false,
      nameError: "",
      okToast: false,
      okText: "",
      errorToast: false,
      newcustomer: {
        name: "",
        enable_gps: 1,
        start_day_per_month: 1,
        bluetooth_pin: "0000",
        outpost: 0,
        enable_tts: 0,
        enable_cancel: 1,
        max_cancel_time: 10,
        enable_azure_upload: 0,
        enable_aws_upload: 1,
        enable_ftp_upload: 0,
        ftp_host: "",
        ftp_user: "",
        ftp_password: "",
        ftp_sales_path: "",
        ftp_sales_filename: "",
        is_landshut: 0,
        cust_printname: "",
        show_all_places: 1,
        use_calendar: 0,
        offline_login: 0,
        customer_url: "",
        customer_tel: "",
        global_location_filter: "",
        enable_sumup: 0,
        sumup_affiliate_key: "",
        enable_gtfs_download: 0,
        enable_vdv_download: 0,
        printer_width: 550,
        printer_types:
          "SPP-R200,SRP-350III,SRP-350plusIII,SPP-R300,SPP-R310,SRP-Q300",
        vdv_data_provider: "BCN",
        use_offline_gps: 0,
      },
      defaultCustomerValues: {
        name: "",
        enable_gps: 1,
        start_day_per_month: 1,
        bluetooth_pin: "0000",
        outpost: 0,
        enable_tts: 0,
        enable_cancel: 1,
        max_cancel_time: 10,
        enable_azure_upload: 0,
        enable_aws_upload: 1,
        enable_ftp_upload: 0,
        ftp_host: "",
        ftp_user: "",
        ftp_password: "",
        ftp_sales_path: "",
        ftp_sales_filename: "",
        is_landshut: 0,
        cust_printname: "",
        show_all_places: 1,
        use_calendar: 0,
        offline_login: 0,
        customer_url: "",
        customer_tel: "",
        global_location_filter: "",
        enable_sumup: 0,
        sumup_affiliate_key: "",
        enable_gtfs_download: 0,
        enable_vdv_download: 0,
        printer_width: 550,
        printer_types:
          "SPP-R200,SRP-350III,SRP-350plusIII,SPP-R300,SPP-R310,SRP-Q300",
        vdv_data_provider: "BCN",
        use_offline_gps: 0,
      },
    };
  },
  methods: {
    // wie bisher POST customer mit den Vorgabewerten; neu: Name Pflicht, Rückmeldung als Toast, danach ein frisches
    // Formular (vorher zeigte es auf dasselbe Objekt wie die Vorgaben, weitere Eingaben änderten diese mit)
    async createCustomer() {
      if (this.loading) {
        return;
      }
      if (!String(this.newcustomer.name || "").trim()) {
        this.nameError = "Pflichtfeld";
        return;
      }
      this.loading = true;
      try {
        await axios.post(`${this.$store.state.baseUrl}customer`, this.newcustomer);
        this.okText = `Kunde „${this.newcustomer.name}“ angelegt.`;
        this.okToast = true;
        this.newcustomer = Object.assign({}, this.defaultCustomerValues);
      } catch (e) {
        this.errorToast = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Formular wie Kundeneinstellungen: Karte mit Labels über den Feldern und Fuß mit der Hauptaktion */
.nc-panel {
  max-width: 600px;
}
.nc-form {
  padding: 16px;
}
.nc-foot {
  min-height: var(--h-foot);
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 4px 16px;
  background: var(--band);
  border-top: 1px solid var(--line);
}
@media (max-width: 599.98px) {
  .nc-form {
    padding: 12px;
  }
  .nc-foot {
    padding: 4px 12px;
  }
}
</style>
